var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6388 1.77197C8.6388 2.08836 8.38237 2.34478 8.06598 2.34478H2.97999C2.03126 2.3459 1.26243 3.11451 1.26154 4.06324V20.1359C1.26243 21.0846 2.03126 21.8532 2.97999 21.8544H17.907C18.8555 21.8532 19.6244 21.0846 19.6255 20.1359V15.0499C19.6255 14.7335 19.8819 14.4771 20.1983 14.4771C20.5145 14.4771 20.7711 14.7335 20.7711 15.0499V20.1359C20.7693 21.717 19.4881 22.9982 17.907 23H2.97976C1.3987 22.9982 0.117466 21.717 0.115677 20.1359V4.06324C0.117466 2.48217 1.3987 1.20094 2.97976 1.19915H8.06598C8.38237 1.19915 8.6388 1.45557 8.6388 1.77197Z",
    fill: "#8392A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.245 1.42607C23.2517 2.43275 23.2517 4.06483 22.245 5.07151L12.0256 15.2909C11.9555 15.361 11.8687 15.4115 11.7734 15.4379L6.92167 16.7818C6.72275 16.8371 6.50974 16.7809 6.36362 16.635C6.21774 16.4889 6.16157 16.2759 6.21662 16.077L7.56072 11.2253C7.58713 11.13 7.6377 11.0431 7.70773 10.9731L17.9274 0.753901C18.9347 -0.251217 20.5655 -0.251217 21.5728 0.753901L22.245 1.42607ZM11.6532 14.0428L20.0173 5.67901L17.3199 2.98162L8.95585 11.3457L11.6532 14.0428ZM10.572 14.5816L8.41682 12.4266L7.59093 15.4075L10.572 14.5816ZM18.7374 1.5639L18.1299 2.1714L20.8275 4.86901L21.435 4.26129C21.9942 3.70212 21.9942 2.79546 21.435 2.23629L20.7628 1.5639C20.203 1.00563 19.297 1.00563 18.7374 1.5639Z",
    fill: "#8392A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.97b3fa7693d1c10f91f7de92317fc7d7.svg";
export { ForwardRef as ReactComponent };